import React from "react";
import { CURRENT_YEAR } from "../../configs/AppConfig";

export default function CustomerSleeveFooter() {
  return (
    <footer className="customer-sleeve-footer text-white px-4 py-3 d-flex align-items-center text-center justify-content-center rounded-0">
      <div className="text-white small ">
        Copyright {CURRENT_YEAR} @ <span className="text-white">DocuSafe.ai</span> All rights reserved
        <br />
        Made with by alumni of IIM Ahmedabad and BITS Pilani
      </div>
    </footer>
  );
} 